<template>
    <app-page-options :options="options" />
</template>
<script>
    import PageOptions from '../UI/Controls/PageOptions/PageOptionsList.vue';
    export default {
        components: {
            appPageOptions: PageOptions
        },
        data(){
            return {
                options: []
            }
        },
        methods: {
            setOptions(){
                const options = !!this.user.position && !!this.user.position.position_options ? this.user.position.position_options : [];

                const optionsOrdered = options.sort((a, b) => a.order - b.order);
                this.options = optionsOrdered;
            }
        },
        created(){
            this.setOptions();
        }

    }
</script>